export default "__VITE_ASSET__B_rQ6j1a__"